<template>
  <div v-if="hasActiveFilters" class="flex flex-wrap items-center gap-2">
    <!-- Marka Filtreleri -->
    <UBadge
      v-for="brandId in activeFilters.brands"
      :key="`brand-${brandId}`"
      color="orange"
      variant="solid"
      class="items-center text-sm"
    >
      <span class="mr-1 truncate">{{ getBrandName(brandId) }}</span>
      <UButton
        color="white"
        variant="link"
        icon="i-heroicons-x-mark-20-solid"
        class="-mr-1.5"
        size="2xs"
        @click="$emit('remove-brand', brandId)"
      />
    </UBadge>

    <!-- Fiyat Filtresi -->
    <UBadge
      v-if="activeFilters.price.min !== null || activeFilters.price.max !== null"
      color="orange"
      variant="solid"
      class="items-center text-sm"
    >
      <span class="mr-1 truncate">
        {{ formatPriceRange(activeFilters.price.min, activeFilters.price.max) }}
      </span>
      <UButton
        color="white"
        variant="link"
        icon="i-heroicons-x-mark-20-solid"
        class="-mr-1.5"
        size="2xs"
        @click="$emit('remove-price')"
      />
    </UBadge>

    <!-- Özellik Filtreleri -->
    <template v-for="(terms, attributeId) in activeFilters.attributes" :key="`attr-${attributeId}`">
      <UBadge
        v-for="termId in terms"
        :key="`term-${termId}`"
        color="orange"
        variant="solid"
        class="items-center text-sm"
      >
        <span class="mr-1 truncate">{{ getAttributeTermName(attributeId, termId) }}</span>
        <UButton
          color="white"
          variant="link"
          icon="i-heroicons-x-mark-20-solid"
          class="-mr-1.5"
          size="2xs"
          @click="$emit('remove-attribute', { attributeId, termId })"
        />
      </UBadge>
    </template>

    <!-- Tümünü Temizle -->
    <UButton
      v-if="hasActiveFilters"
      color="gray"
      variant="soft"
      size="xs"
      icon="i-heroicons-trash"
      class="shrink-0"
      @click="$emit('reset')"
    >
      Tümünü Temizle
    </UButton>
  </div>
</template>

<script setup>
const props = defineProps({
  filters: {
    type: Object,
    required: true
  },
  activeFilters: {
    type: Object,
    required: true
  }
})

defineEmits(['remove-brand', 'remove-price', 'remove-attribute', 'reset'])

// Aktif filtre kontrolü
const hasActiveFilters = computed(() => {
  return (
    props.activeFilters?.brands?.length > 0 ||
    props.activeFilters?.price?.min !== null ||
    props.activeFilters?.price?.max !== null ||
    Object.keys(props.activeFilters?.attributes || {}).length > 0
  )
})

// Marka ismini bul
const getBrandName = (brandId) => {
  const brand = props.filters?.brands?.find(b => b.id === brandId)
  return brand?.name || ''
}

// Özellik terim ismini bul
const getAttributeTermName = (attributeId, termId) => {
  const attribute = props.filters?.attributes?.find(a => a.id === Number(attributeId))
  const term = attribute?.terms?.find(t => t.id === termId)
  return term?.name || ''
}

// Fiyat aralığını formatla
const formatPriceRange = (min, max) => {
  if (min !== null && max !== null) {
    return `${formatPrice(min)} - ${formatPrice(max)}`
  } else if (min !== null) {
    return `${formatPrice(min)} ve üzeri`
  } else if (max !== null) {
    return `${formatPrice(max)} ve altı`
  }
  return ''
}
</script> 